/**
 * CODE_COMMENTS_31
 * CODE_COMMENTS_58
 */

export const REPORT_OUTBOUND_SHIPMENTS_FIELD_ARRAY_NAME = 'outboundShipmentsToEverywhereExceptPubsAndSelfDistribution'
